import { Injectable, inject } from "@angular/core";
import { HttpService } from "@shared/services";

@Injectable({ providedIn: 'root' })
export class FormulaDefinitionService {
  private httpService = inject(HttpService);

  calculateFormula(formula: string) {
    return this.httpService.post<any>('_api/FieldDefinition/calculate-formula', formula);
  }
}